class WelcomeModal {
    constructor() {
		if (document.querySelector("#willkommen")) {
			this.body = document.querySelector('body');
			this.modal = document.getElementById('willkommen');

            // this.events();
		}
    }

    events() {
		const observer = new MutationObserver((mutationsList, observer) => {

			// Check if the body element now has the "has-plugin-bootstrap" class
			if (this.body.classList.contains('has-plugin-bootstrap')) {
				observer.disconnect();
				this.showModal();
			}
		});

		// Start observing the body element for changes to its class list
		observer.observe(this.body, { attributes: true, attributeFilter: ['class'] });
	}

	showModal() {
		// Get the modal element
		this.modal = document.getElementById('willkommen');

		// Create a new instance of the Bootstrap modal
		const modalInstance = new bootstrap.Modal(this.modal);

		// Show the modal
		modalInstance.show();
	}
}

export default WelcomeModal;
